import React, { useContext } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ChartContext } from "../Dashboard/Dashboard";

const BChart = () => {
  const data = useContext(ChartContext);
  return (
    <div>
      <h3>Investment Vs. Revenue</h3>

      <BarChart
        width={450}
        height={300}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="investment" stackId="a" fill="#EE5A24" />
        {/* <Bar dataKey="sell" stackId="a" fill="#82ca9d" /> */}
        <Bar dataKey="revenue" fill="#009432" />
      </BarChart>
    </div>
  );
};

export default BChart;
